import * as actionTypes from '../constants/actionTypes';
import flashMessage from './flashMessage';
import httpError from './httpError';

export { flashMessage, httpError };

export const loadFormDataAction = (form, id) => ({
    type: actionTypes.FORM_DATA_LOAD,
    payload: {
        form,
        id
    }
});

export const loadDataAction = (resource) => ({
    type: actionTypes.DATA_LOAD_REQUEST,
    payload: {
        resource
    }
});

export const loadDataDoneAction = (resource) => ({
    type: actionTypes.DATA_LOAD_DONE,
    payload: {
        resource
    }
});

export const loadDataSuccessAction = (resource, message) => ({
    type: actionTypes.DATA_LOAD_SUCCESS,
    payload: {
        resource,
        message
    }
});

export const loadDataErrorAction = (resource, error, failedAction) => ({
    type: actionTypes.DATA_LOAD_ERROR,
    payload: {
        resource,
        error,
        failedAction
    }
});